var _path, _path2, _path3, _rect, _path4, _circle, _path5, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFieldvisits = function SvgFieldvisits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFD2A8",
    strokeWidth: 3,
    d: "M35 19.314c14.5-9 29.5-7 29.5-2.5 0 5.5-11 2-11 7s14.5 2 14.5 8c0 8.5-33 9-9 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    d: "M44.22 8.54a2 2 0 0 1 2.17 1.813l4.423 49.486A2 2 0 0 1 49 62.01L8.068 65.67a2 2 0 0 1-2.17-1.815L1.474 14.368a2 2 0 0 1 1.814-2.17zm-1.618 39.586a1.5 1.5 0 0 0-2.113.19l-3.7 4.427-1.854-1.549a1.5 1.5 0 0 0-1.923 2.302l3.004 2.51a1.5 1.5 0 0 0 2.112-.188l4.663-5.578a1.5 1.5 0 0 0-.189-2.114m-29.634-1.649a1.5 1.5 0 0 0 .267 2.988l18.18-1.625.153-.021a1.501 1.501 0 0 0-.266-2.973l-.153.006zm-.573-6.416a1.5 1.5 0 1 0 .267 2.988l22.457-2.007.152-.022a1.5 1.5 0 0 0-.266-2.972l-.153.006zm-.574-6.416a1.5 1.5 0 0 0 .267 2.988l26.735-2.39.152-.022a1.5 1.5 0 0 0-.265-2.972l-.154.006zm12.697-14.72a4.294 4.294 0 1 0 .766 8.554 4.294 4.294 0 0 0-.766-8.555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    d: "M41.15 12.048a2.15 2.15 0 0 1 2.33 1.948l3.824 42.775a2.15 2.15 0 0 1-1.947 2.33l-34.221 3.06a2.15 2.15 0 0 1-2.33-1.948L4.982 17.437a2.15 2.15 0 0 1 1.948-2.33zm1.452 36.078a1.5 1.5 0 0 0-2.113.19l-3.7 4.427-1.854-1.549a1.5 1.5 0 0 0-1.923 2.302l3.004 2.51a1.5 1.5 0 0 0 2.112-.188l4.663-5.578a1.5 1.5 0 0 0-.189-2.114m-29.634-1.649a1.5 1.5 0 0 0 .267 2.988l18.18-1.625.153-.021a1.501 1.501 0 0 0-.266-2.973l-.153.006zm-.573-6.416a1.5 1.5 0 1 0 .267 2.988l22.457-2.007.152-.022a1.5 1.5 0 0 0-.266-2.972l-.153.006zm-.574-6.416a1.5 1.5 0 1 0 .267 2.988l26.736-2.39.151-.022a1.5 1.5 0 0 0-.265-2.972l-.154.006zm12.697-14.72a4.294 4.294 0 1 0 .766 8.554 4.294 4.294 0 0 0-.766-8.555"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.916,
    height: 9.663,
    x: 9.564,
    y: 8.403,
    fill: "#FF9D43",
    rx: 2,
    transform: "rotate(-5.108 9.564 8.403)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    d: "M58.889 29.314c4.08 0 7.388 3.346 7.388 7.473 0 2.781-3.355 9.493-5.544 13.575a2.078 2.078 0 0 1-3.69 0C54.857 46.28 51.5 39.568 51.5 36.787c0-4.127 3.308-7.473 7.389-7.473m0 3.695a3.695 3.695 0 1 0 0 7.389 3.695 3.695 0 0 0 0-7.39"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.889,
    cy: 36.703,
    r: 3.694,
    fill: "#FDFDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    d: "M63.39 8c2.424 0 4.388 1.987 4.388 4.438 0 1.368-1.364 4.335-2.572 6.692a2.023 2.023 0 0 1-3.633 0C60.366 16.773 59 13.806 59 12.439 59 9.987 60.966 8 63.39 8m0 2.194a2.196 2.196 0 1 0 0 4.392 2.196 2.196 0 0 0 0-4.392"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.389,
    cy: 12.389,
    r: 2.195,
    fill: "#FDFDFF"
  })));
};
export default SvgFieldvisits;